<div class="minculturas flex justify-content-between p-0 mb-1" style="height: 40px;">
  <div class="mb-0 minculturas-title">{{ titlePage }}
  </div>
  <div class="hidden md:flex">
    <app-route-indicator></app-route-indicator>
  </div>
</div>
<p-divider type="solid" />